import React from 'react';
import { Divider, Tag } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';
import { CheckCircleOutlined, SyncOutlined } from '@ant-design/icons';
import LocationInfo from './shared-components/LocationInfo';
import { businessAtom } from '../../../atoms/Atoms';

function BusinessLocation() {
  const business = useRecoilValue(businessAtom);
  const { t } = useTranslation();

  return (
    <>
      <PageHeader
        title="General"
        tags={
          <Tag
            color="#2db7f5"
            icon={business ? <CheckCircleOutlined /> : <SyncOutlined spin />}
          >
            {business ? business.name : `${t('loading')}...`}
          </Tag>
        }
      />
      <Divider />
      <LocationInfo />
      <br />
    </>
  );
}

export default BusinessLocation;
